<template src="./template.html" ></template>
<script>
//
import lendingMixin from './mixin'
import MyAlert from '../../components/alert/MyAlert.vue'
import MyPersons from '../../components/MyPersons.vue'
import MyAbouts from '../../components/MyAbouts.vue'
import MyComment from '../../components/MyComment.vue'
import MyLendingType from './MyLendingType.vue'
import MyBalances from '../../components/MyBalances.vue'
import MyButtons from '../add/Buttons.vue'
import MyLendingTable from './table.vue'
//
export default {
  name: 'lendingItems',
  mixins: [lendingMixin],
  methods: {
    async onSave(e) {
      //
      this.$refs.form.validate()
      if (!this.validation || this.submitStatus === 'PENDING') return
      if (!this.model.type && this.route) this.model.type = this.route.slice(0, -1)
      const method = this.formState === 'edit' ? 'PUT' : 'POST'
      const payload = {
        method,
        url: `/api/${this.route}`,
        data: {
          data: this.model
        }
      }
      if (!e?.esc && !window.confirm('آیا مایل به ذخیره سند هستید؟')) return
      try {
        this.submitStatus = 'PENDING'
        await this.$store.dispatch('save', payload)
        const res = this.$store.getters.saveData
        if (res?.insert || res?.update) {
          if (res._id) this.lending_id = res._id
          if (res.data) this.returnSaveData = res.data
          this.showAlert = true
        } else this.submitStatus = null
      } catch (err) {
        console.error(err);
        this.submitStatus = null
      }
    },
    async setBalance() {
      if (!this.model.person_id) {
        this.lendingBalance = 0
        return
      }
      try {
        let res = await this.personBalance(this.model.person_id, 'lendingBalance')
        this.balance.current = res.balance
        this.balance.product = res.product
        this.calcNewLendingBalance(null, this.lendingTotal)
      } catch (e) {
        console.error(e)
      }
    },
    changeLendingType() {
      this.calcNewLendingBalance(null, this.lendingTotal)
    },
    addLendingRow(item) {
      let i = this.model.items.slice();
      let newItem = {
        product: null,
        // n: null,
        lending_value: 0,
        comment: ''
      };
      i.splice(i.indexOf(item) + 1, 0, newItem);
      this.model.items = i
    },
    removeRow(item) {
      let i = this.model.items.slice();
      i.splice(i.indexOf(item), 1);
      this.model.items = i
    },
  },
  computed: {
    lendingTotal() {
      let t = 0
      t = this.model.items.map((item) => {
        if (item.lending_value && item.product.n) {
          return item.lending_value * item.product.n //.toFixed(0);
        } else {
          return 0
        }
      });
      return (t.reduce((a, b) => Number(a) + Number(b), 0))
      // return this.model.items.reduce(
      //   (acc, item) => acc + ((item.value * item.price) * item.n), 0
      // );
    },
    clonedItems: function() {
      return JSON.parse(JSON.stringify(this.model))
    }
  },
  watch: {
    clonedItems: async function(newVal) { //, oldVal
      // console.log(JSON.stringify(newVal.items));
      if (!newVal.person_id) {
        this.balance = {
          current: 0,
          new: 0
        }
      }
    },
    lendingTotal: {
      handler(newVal) {
        this.calcNewLendingBalance(null, newVal)
      }
    },
  },
  async beforeCreate() {
    this.formState = this.$router.currentRoute.path.split("/")[2]
    this.route = this.$store.getters.pageInfo.route
    if (this.formState === 'edit') {
      let _mid = this.$router.currentRoute.path.split("/")[3]
      let data = {
        url: `/api/${this.route}`,
        params: {
          mid: _mid
        },
      }
      await this.$store.dispatch('getInfo', data)
      this.model = this.$store.getters.editData
      // console.log((this.model));
      this.prevPerson_id = this.model.person_id
      this.model.items.forEach((item) => {
        this.prevBalance += Number(item.lending_value * item.product.n)
      })
      this.setBalance()
    }
  },
  created() {
    if (this.formState === 'edit') return
    this.model.type = 'pay'
    this.addLendingRow(this.model)
  },
  mounted() {
    if (this.$refs.vradio) {
      this.$refs.vradio.$el.children[0].children[1].focus()
    }
    // if (this.formState === 'add' && this.$refs.focus) {
    //   this.$refs.list.focus()
    // } else if (this.formState === 'edit' && this.$refs.vradio) {
    // this.$refs.vradio.$el.children[0].children[1].focus()
    // }
  },
  data() {
    return {
      submitStatus: null,
      validation: false,
      showAlert: false,
      returnSaveData: Object,
      lending_id: null,
      prevPerson_id: null,
      prevBalance: 0,
      model: {
        type: null,
        items: [],
      },
      balance: {
        current: 0,
        new: 0
      },
      lendingBalance: 0,
    }
  },
  props: ['formTitle'],
  components: {
    MyAlert,
    MyButtons,
    MyPersons,
    MyAbouts,
    MyComment,
    MyLendingType,
    MyBalances,
    MyLendingTable,
  },
}
</script>
<style lang="scss">
@import '../doc/doc.css';
</style>
